import { useRef, useState } from "react";
import JornadaAnioFilter from "../../components/Filters/JornadaAnioFilter";
import { Button } from "react-bootstrap";
import asistenciaService from "../../services/asistenciaService";
import moment from "moment";
import HeaderActa from "../../components/headerActas";
import utils from '../../utils/generalFunctions';
import academicService from "../../services/academicService";
import { toast } from 'react-toastify';
import Loading from "../../components/Loading";
import JornadaAnioPeriodoNivelCursoAsigAll from "../../components/Filters/JornadaAnioPeriodNivelCursoAsigAll";
import FooterActa from "../../components/FooterActa";
import types from "../../services/types";

const RepoAsistenciaTotalAsig = () => {
    const filteReference = useRef(null);
    const initData ={
        schoolYearId: "0",
        journeyId:"0",
        startDate: "",
        periodId:"",
    };
    const [formData, setFormData] = useState(initData);
    const [asistencias, setAsistencias] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [datosBusqueda, setDatosBusqueda] = useState([]);
    const [periodos, setPeriodosList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    
    
    const updateForm = async (data) => {
        if (data.schoolYearId!==formData.schoolYearId){   
          await cargarPeriodos(data.schoolYearId);
        }
        setFormData(prevState => ({
            ...prevState,
            ...data
          }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const cargarPeriodos = async (schoolYearId) => {
        try {
            const schoolYear = await academicService.getYearById(schoolYearId);              
            if(schoolYear){
                setPeriodosList(schoolYear.periods)
            }            
        } catch (error) {
             console.error("Error al obtener información de año escolar:", error);
        }
      }

    const generarCosolidadReporteTotal = async () =>{
        const requiredFields = ['schoolYearId', 'journeyId', 'startDate','periodId','educationLevelId','courseId','schoolSubjectId'];
        for (let field of requiredFields) {
            if (!formData[field] || formData[field]==='0') {
                toast.error("Por favor, completa todos los campos obligatorios.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                return;
            }
        }
        setDatosBusqueda([]);
        setShowLoading(true);
        try {
           const copyData = utils.copy(formData);
           copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
           const years = filteReference.current?.getSchoolYears();
           if(years){
                copyData.year = years.find(p=>String(p.schoolYearId)===String(copyData.schoolYearId))?.year??"";
           }
           const journeys = filteReference.current?.getJourneys();
           if(journeys){
                copyData.journey = journeys.find(p=>String(p.journeyId)===String(copyData.journeyId))?.name??"";
           }

           const courses = filteReference.current?.getCursos();
           if(courses){
                copyData.course = courses.find(p=>String(p.courseId)===copyData.courseId)?.name??"";
           }

           setDatosBusqueda(copyData);
           const date = moment(formData.startDate).format("yyyy-MM-DD");
           const asistenciasDB = await asistenciaService.getAsistenciasTotalReportSubject(formData.schoolYearId, formData.periodId, date, formData.courseId, formData.schoolSubjectId);
            if(asistenciasDB && asistenciasDB.length>0){
                setAsistencias(asistenciasDB);

                const allSubjects = utils.removeDuplicates(asistenciasDB.map((o) => {return {schoolSubjectId: o.schoolSubjectId, name: o.schoolSubjectName, courseId: o.courseId, courseName: o.courseName, educationLevelId: o.educationLevelId, educationLevelName: o.educationLevelName}}));
                setSubjects(allSubjects);
                
            }else{
                setAsistencias([]);
                toast.error("No se encontraron asistencias para la fecha seleccionada.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
            }
        } catch (error) {
          console.error("Error al obtener asistencias:", error);
        }
        setShowLoading(false);
    }

    return (
        <>
          <div className="card p-3 filter-container">
            <h1>Consolidado total asistencias por asignatura</h1>
            <p>Selecciona los filtros para generar el reporte.</p>
            
                <div className="row">
                    <JornadaAnioPeriodoNivelCursoAsigAll
                                callback={updateForm}
                                ref={filteReference}
                                loadTutoria={true}
                                loadCoordinators={true}
                                properties={
                                    {
                                        className:'col-md-3 mb-2',
                                        id:'formReport2',
                                        filtro:false
                                    }
                                }
                            />
                        <div className="col-md-3 mb-3">
                            <label htmlFor="startDate" className="col-form-label  text-sm-right">Fecha de asistencia</label>
                            <input type="date" className="form-control" id="startDate" name="startDate" placeholder="Seleccione la fecha de asistencia" value={formData.startDate} onChange={handleChange} required />
                        </div>
                        <div className="col-md-2 mb-1 mt-4">
                                <button onClick={generarCosolidadReporteTotal} className="ml-2 btn btn-primary">Buscar</button>
                        </div>
                </div>
          </div>
          {showLoading && <Loading />}

          {!showLoading && asistencias.length>0 && (

                    <div className="">
                    <div className="card acta-container">
                        <div className="card-body">

                                {/* Cabezera */}
                                <HeaderActa />

                                
                                {/* Ficha de Incidencia */}
                                <section className="incidencia-info">
                                <div class="info-header">
                                    <h5 class="section-title">ASISTENCIA ESCOLAR</h5>
                                </div>
                                <div class="info-body">
                                    
                                    <div class="info-item">
                                        <span class="info-title">Año escolar:</span>
                                        <span class="info-content">{datosBusqueda.year}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title">Fecha de asistencia:</span>
                                        <span class="info-content">{moment(datosBusqueda.startDate).format('DD-MM-YYYY')}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title">Jornada:</span>
                                        <span class="info-content">{datosBusqueda.journey}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title">Periodo:</span>
                                        <span class="info-content">{datosBusqueda.periodName}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title">Fecha de impresion:</span>
                                        <span class="info-content">{moment().format('DD-MM-YYYY')}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title">Curso:</span>
                                        <span class="info-content">{datosBusqueda.course}</span>
                                    </div>
                                
                                </div>
                                </section>
                                
                
                                {/* Implicados */}
                                
                                        
                                
                                <section className="incidencia-implicados">
                                        <h5 className="section-title">Consolidado de asistencia</h5>
                                        <table className="tabla-implicados">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Estudiante</th>
                                                <th>Total asistencias</th>
                                                <th>Total inasistencias</th>
                                                <th>Total excusas</th>
                                                <th>Total llegadas tarde</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {asistencias?.map((a, index) => (
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{a.studentFullName}</td>
                                                <td>{a?.assists??'0'}</td>
                                                <td>{a?.noAssists??'0'}</td>
                                                <td>{a?.excuses??'0'}</td>
                                                <td>{a?.lates??'0'}</td>
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </section>

                                <section className="incidencia-implicados">
                                    <h5 className="section-title">Total</h5>
                                    <table className="tabla-implicados">
                                    <thead>
                                        <tr>
                                            <th>Total asistencias</th>
                                            <th>Total inasistencias</th>
                                            <th>Total excusas</th>
                                            <th>Total llegadas tarde</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{(asistencias.reduce((sum, a) => {return sum + Number(a.assists??0);}, 0))}</td>
                                            <td>{(asistencias.reduce((sum, a) => {return sum + Number(a.noAssists??0);}, 0))}</td>
                                            <td>{(asistencias.reduce((sum, a) => {return sum + Number(a.excuses??0);}, 0))}</td>
                                            <td>{(asistencias.reduce((sum, a) => {return sum + Number(a.lates??0);}, 0))}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </section>
                                <FooterActa
                                reportTypeId={types.reportTypes.ASISTENCIA}></FooterActa>
                        </div>
                    </div>
                                <br />
                                    <button className="btn btn-primary center display-block" onClick={() => window.print()}>Imprimir</button>
                                <br />
                    </div>

          )}
        </>
    );
  };
  
  export default RepoAsistenciaTotalAsig;